import { setOpenTaskId } from "../../../app-time/utils/timeManager.js";
import { createEntry, updateEntry } from "../../../app-table/tableManager/entryManager.js";
import { currentTable, setView } from "../../../../../app/viewManager.js";
import { fillDialogDropdowns, selectDialogDropdowns, setHoursWarnTime } from "../dropdowns/dropdownManager.js";
import { currentContext } from "../core/dialogContext.js";
import { withClose, onEdit, animateRow } from "../core/dialogHandlerUtils.js";

export function buildCreateEntryHandlers(data, isTask) {
    return {
        onSave: withClose(async () => {
            const raw = await createEntry(isTask);
            if (!raw || raw === true) return raw;

            const needsNav = !isTask && currentTable?.tableName !== 'entry';
            if (isTask) setOpenTaskId(raw.id);

            if (isTask || needsNav) {
                const entryId = raw.id;
                await setView('Entries');
                const table = currentTable;

                const onDataLoaded = () => {
                    table.off('dataLoaded', onDataLoaded);
                    setTimeout(() => {
                        const row = table.getRows().find(entry => entry.getData().id == entryId);
                        if (!row) return;
                        try { table.scrollToRow(row, 'center', false); } catch (_) {}
                        const element = row.getElement();
                        if (!element) return;
                        element.classList.remove("row-flash-create");
                        void element.offsetWidth;
                        element.classList.add("row-flash-create");
                        setTimeout(() => element.classList.remove("row-flash-create"), 1900);
                    }, 100);
                };
                table.on('dataLoaded', onDataLoaded);
            } else {
                animateRow(raw.id, "row-flash-create");
            }
            return raw;
        }),
        setup: async () => {
            await fillDialogDropdowns();
            if (data) { const { date, ...rest } = data; await selectDialogDropdowns(rest); }
            setHoursWarnTime();
        }
    };
}

export function buildEditEntryHandlers(data) {
    currentContext.id = data?.id;
    return {
        onSave: onEdit(updateEntry),
        setup: async () => {
            await fillDialogDropdowns();
            await selectDialogDropdowns(data);
            setHoursWarnTime();
        }
    };
}